import { render } from "./loadScreenComponent.vue?vue&type=template&id=45413864"
import script from "./loadScreenComponent.vue?vue&type=script&lang=js"
export * from "./loadScreenComponent.vue?vue&type=script&lang=js"

import "./loadScreenComponent.vue?vue&type=style&index=0&id=45413864&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__